<template>
  <div
    id="component-list-board"
    class="component-card">
    <b-row>
      <b-col
        id="list-board"
        md="4"
        class="list-boards p__r--0"
        style="padding-right: 0;">
        <b-row class="component-header">
          <b-col
            cols="12"
            class="component-title p__t--15">
            <b-row>
              <b-col
                cols="12">
                <h3>BOARD</h3>
              </b-col>
            </b-row>
            <b-row>
              <b-col
                cols="10"
                class="pr-0">
                <b-form
                  @keyup.enter="searchBoard()">
                  <j-input
                    v-model="filter_data"
                    placeholder="Search"
                    class="m__r--5"/>
                    <!-- <p
                    v-if="isLoadingSearch">
                    <b>Loading...</b>
                  </p> -->
                </b-form>
              </b-col>
              <b-col
                cols="2"
                @click="addNewBoard">
                <i class="fa fa-plus font-weight-bold cursor-pointer m__t--5"/>
              </b-col>
            </b-row>

            <!-- MODAL CREATE BOARD -->
            <b-modal
              ref="modalCreateBoard"
              class="mod-form"
              centered>
              <h3>CREATE BOARD</h3>
              <b-form-group :class="{'error-input' : $v.data_create_board.name.$error}">
                <label> Board Name* </label>
                <j-input
                  v-model="$v.data_create_board.name.$model"
                  :max-length="255"
                  placeholder="Board Name"/>
              </b-form-group>
              <b-form-group :class="{'error-input' : $v.data_create_board.description.$error}">
                <label> Description* </label>
                <j-textarea
                  v-model="$v.data_create_board.description.$model"
                  :max-length="300"
                  placeholder="Description"/>
              </b-form-group>
              <br>
              <b-row>
                <b-col>
                  <div class="float-to-right">
                    <b-button
                      class="btn blue m__r--5"
                      @click="createBoard">
                      Create
                    </b-button>
                    <b-button
                      class="btn gray"
                      @click="closeCreateBoard">
                      Close
                    </b-button>
                  </div>
                </b-col>
              </b-row>
            </b-modal>

          </b-col>
        </b-row>
        <b-row class="component-body">
          <div
            v-for="(item, index) in listBoardSetting"
            :key="item.id"
            :class="{ 'active': boardIndex === index }"
            class="col-12 d-flex justify-content-between
              component-card cursor-pointer align-items-end"
            @click="switchBoard(item, index)">
            <div class="d-flex">
              <div class="m__r--10">
                <i
                  class="fa fa-table font-weight-medium cursor-pointer m__t--5"/>
              </div>
              <div>
                <h4 class="title-board-component">{{ item.name }}</h4>
                <p class="id-board-component">ID: {{ item.id }}</p>
              </div>
            </div>
            <div
              class="d-flex flex-column align-items-end">
              <span class="text-action"><b>View</b></span>
            </div>
          </div>
        </b-row>
        <!-- <b-row class="m__t--10">
          <b-col
            class="text-align-center"
            cols="12">
            <button
              v-if="!isLoadingForms && isNextPage"
              class="load-more-button"
              @click="loadMore">
              Load More
            </button>
            <p
              v-if="isLoadingForms">
              <b>Loading...</b>
            </p>
          </b-col>
        </b-row> -->
      </b-col>
      <b-col
        md="8"
        style="padding-right: 0;">
        <j-board-setting-detail
          v-if="board !== null"
          :board="board"

          :key="board.id" />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { required } from 'vuelidate/lib/validators';
import jBoardSettingDetail from '@/views/board/jBoardSettingDetail';

export default {
  /* eslint-disable vue/name-property-casing */
  name: 'jBoardSetting',
  components: {
    jBoardSettingDetail,
  },
  validations: {
    data_board: {
      title: {
        required,
      },
      board: {
        required,
      },
    },
    data_create_board: {
      name: {
        required,
      },
      description: {

      },
    },
  },
  data() {
    return {
      filter_data: '',
      listBoardSetting: [],
      data_board: {
        title: '',
        board: null,
      },
      data_create_board: {
        name: '',
        description: '',
      },

      // Active board
      board: null,
      boardIndex: 0,
    };
  },
  computed: {
    ...mapState('jStoreApplication', ['list_board_setting']),
  },
  watch: {
    list_board_setting(data) {
      this.listBoardSetting = data;

      if (data.length > 0) {
        this.board = data[0];
      }
    },
  },
  created() {
    this.actionGetListBoardSetting();
  },
  methods: {
    ...mapActions('jStoreApplication', ['actionGetListBoardSetting', 'createNewBoard']),

    closeBoard() {
      this.$emit('close-field');
      this.data_board.title = '';
      this.data_board.board = null;
      setTimeout(() => {
        this.$v.data_board.$reset();
      }, 1000);
    },

    addNewBoard() {
      this.$refs.modalCreateBoard.show();
    },

    createBoard() {
      this.$v.data_create_board.$touch();
      if (!this.$v.data_create_board.$error) {
        const dataParam = {
          additional_info: [],
          description: this.data_create_board.description,
          id: 0,
          is_delete: false,
          name: this.data_create_board.name,
          smart_connect: {
            id: 0,
            is_use_amount: false,
            is_use_category: false,
            product_types: [],
          },
        };
        this.createNewBoard(dataParam).then(() => {
          this.actionGetListBoardSetting();
        });

        this.closeCreateBoard();
      }
    },

    closeCreateBoard() {
      this.$refs.modalCreateBoard.hide();
      this.data_create_board.name = '';
      this.data_create_board.description = '';
      setTimeout(() => {
        this.$v.data_create_board.$reset();
      }, 1000);
    },

    switchBoard(item, index) {
      this.board = item;
      this.boardIndex = index;
    },


    searchBoard() {
      let filteredBoard = this.list_board_setting;

      filteredBoard = filteredBoard.filter(e =>
        e.name.toLowerCase().includes(this.filter_data.toLowerCase()));

      this.listBoardSetting = filteredBoard;
    },
  },
};
</script>

<style lang="scss">
  #component-list-board {
    margin-top: 40px;
    padding: 0px 15px 0px 15px !important;
    border: 1px solid #f1f1f1;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    background-color: #fff;
    .fa.fa-plus:before {
      font-size: 24px;
    }
  }

  .text-align-center{
    text-align: center;
  }

  .cursor-pointer {
    cursor: pointer;
  }

  .component-header {
    border: solid 1px #f1f1f1;
    border-top-left-radius: 8px;
    box-shadow: 0 2px 8px 0 rgba(150, 149, 149, 0.21);
    align-items: center;

    i {
      &:hover {
        color: #1a85e4;
      }
    }
  }

  #list-board  {
    .component-body {
      border: solid 1px #f1f1f1;
    }
    .component-card {
      padding: 10px 20px;
      padding-top: 20px;
      border-bottom: solid 1px #f1f1f1;
      h4 {
        margin-bottom: 0;
        &.title-board-component{
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
          max-width: 250px;
        }
      }
      &:hover, &.active {
        background-color: #f2f9ff;
      }

      .text-action {
        color: #1a85e4;
        font-weight: bold;
        font-size: 14px;
        &:hover {
          text-decoration: underline;
        }
      }
      .fa.fa-table:before{
        font-size: 30px;
        color: #1a85e4;
      }
    }

    .active-file {
      border-color: #1a85e4;
      background-color: rgba(26, 133, 228, 0.06);
    }
    .load-more-button {
      border-radius: 16px;
      padding: 10px 30px;
      border: 0;
      background-color: #f2f2f2;
      color: #525252;
    }
  }

  .pdf-reader {
    ::-webkit-scrollbar {
      width: 8px;
    }

    ::-webkit-scrollbar-track {
      background: #f1f1f1;
    }

    ::-webkit-scrollbar-thumb {
      background: #888;
    }

    ::-webkit-scrollbar-thumb:hover {
      background: #555;
    }
  }

  .modal-upload-file .modal-dialog {
    max-width: 600px !important;
  }

  .list-boards .component-body{
    max-height: 750px;
    overflow-x: auto !important;
  }
</style>



// WEBPACK FOOTER //
// src/views/board/jBoardSetting.vue